import { SCROLL_TOP_BUFFER as e } from "./atoms-v2776.js";
function p(r, t, n) {
  var c;
  if (!r.current || !t.current || !n)
    return 0;
  const s = n.split("-").slice(0, 2).join("-"), o = t.current[s], i = ((c = o == null ? void 0 : o.ref) == null ? void 0 : c.getBoundingClientRect().top) ?? 0;
  return (r.current.scrollTop ?? 0) + i - e;
}
export {
  p as getScrollToPosition
};
